// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1371":"256f1d87","4692":"d5e79295","5231":"3b087e2f","7240":"0832f934"}[chunkId] + ".chunk.css";
};